"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var request_node_1 = require("../request/request.node");

var userAgent_1 = require("../tools/userAgent");
/**
 * Complete multipart uploading.
 */


function multipartUpload(part, url, _a) {
  var publicKey = _a.publicKey,
      cancel = _a.cancel,
      onProgress = _a.onProgress,
      integration = _a.integration;
  return request_node_1.default({
    method: 'PUT',
    url: url,
    headers: {
      'X-UC-User-Agent': publicKey ? userAgent_1.getUserAgent({
        publicKey: publicKey,
        integration: integration
      }) : undefined
    },
    data: part,
    onProgress: onProgress,
    cancel: cancel
  }).then(function (result) {
    // hack for node ¯\_(ツ)_/¯
    if (onProgress) onProgress({
      value: 1
    });
    return result;
  }).then(function (_a) {
    var status = _a.status;
    return {
      code: status
    };
  });
}

exports.default = multipartUpload;